import { render, staticRenderFns } from "./DashboardBlock.vue?vue&type=template&id=3b921fe0&"
import script from "./DashboardBlock.vue?vue&type=script&lang=js&"
export * from "./DashboardBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports